import { ReactNode } from "react";
import { ListBox } from "react-aria-components";
import { usePlosTranslations } from "../../../contexts/PlosTranslationsContext";
import { popoverMenuContainer, popoverOuterContainer } from "../popover.css";

interface PopoverListBoxProps {
  children: ReactNode;
}

const FilterListBox = ({ children, ...props }: PopoverListBoxProps) => {
  const { filterOptions } = usePlosTranslations();
  return (
    <div className={popoverOuterContainer}>
      <ListBox
        className={popoverMenuContainer}
        layout="grid"
        orientation="vertical"
        autoFocus
        aria-label={filterOptions}
        {...props}
      >
        {children}
      </ListBox>
    </div>
  );
};

export default FilterListBox;
